import { render, staticRenderFns } from "./PresentationThumbnail.vue?vue&type=template&id=07253013&"
import script from "./PresentationThumbnail.vue?vue&type=script&lang=js&"
export * from "./PresentationThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./PresentationThumbnail.vue?vue&type=style&index=0&id=07253013&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports